import talk2Api from 'src/plugins/api/api'

// A Power Dialer tab's lease on the agent's wrap-up (api-core PowerDialerWrapUpHold). While this tab
// holds it, only status writes carrying this tab's token can take the agent out of wrap-up.
export const WRAP_UP_HOLD_RENEW_MS = 20 * 1000
export const WRAP_UP_HOLD_REFUSAL_CODE = 'power_dialer_wrap_up_hold'

const token = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
  ? crypto.randomUUID()
  : `${Date.now()}-${Math.random().toString(36).slice(2)}`

// True from the moment this tab asks for the hold until it lets go, not only once the server
// granted it: a Finish sent while the acquire is still in flight must carry the token too.
let wanted = false

// The token to send with this tab's own status writes, or null when this tab wants no hold.
export function wrapUpHoldToken () {
  return wanted ? token : null
}

// Request fields that let this tab's own status writes through the hold it holds.
export function wrapUpHoldParams () {
  return wanted ? { wrap_up_hold_token: token } : {}
}

// Takes or renews the lease. Resolves to whether the server holds it for this tab.
export function acquireWrapUpHold (userId) {
  wanted = true
  return Promise.resolve(talk2Api.V1.users.holdWrapUp(userId, token))
    .then(({ data }) => {
      const held = Boolean(data?.held)
      // The tab let go while this acquire was in flight; the server must not keep it.
      if (held && !wanted) {
        sendRelease(userId)
      }
      return held
    })
    .catch((err) => {
      console.log('Talk-WrapUpHold: acquire failed', err)
      return false
    })
}

export function releaseWrapUpHold (userId) {
  if (!wanted) {
    return Promise.resolve(false)
  }
  wanted = false
  return sendRelease(userId)
}

function sendRelease (userId) {
  return Promise.resolve(talk2Api.V1.users.releaseWrapUpHold(userId, token))
    .then(({ data }) => Boolean(data?.released))
    .catch((err) => {
      console.log('Talk-WrapUpHold: release failed', err)
      return false
    })
}

// A status write another tab's hold refused: answered with the held status and a reason to show.
export function isWrapUpHoldRefusal (err) {
  return err?.response?.status === 409 && err?.response?.data?.code === WRAP_UP_HOLD_REFUSAL_CODE
}
